
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sic-stats-block--wrapper{
  display:flex;
  flex-direction:column;
  width:100%;
  justify-content:space-between;
  column-gap:5%;
}
  @media (min-width: 768px){.sic-stats-block--wrapper{
    flex-direction:row
}
  }

.sic-stats-block--icon{
  width:100%;
  margin:0 auto;
  max-width:50%;
}

@media (min-width: 768px){

.sic-stats-block--icon{
    max-width:40%
}
  }

@media (min-width: 1380px){

.sic-stats-block--icon{
    max-width:30%
}
  }

.sic-stats-block--content{
  display:flex;
  flex-direction:column;
  row-gap:var(--spacing-06);
  width:100%;
}

@media (min-width: 1920px){

.sic-stats-block--content{
    max-width:60%
}
  }

.sic-stats-block--info{
  display:flex;
  flex-direction:column;
  row-gap:var(--spacing-05);
}

@media (min-width: 1920px){

.sic-stats-block--info{
    max-width:75%
}
  }

.sic-stats-block--info slot[name='description']{
    --sic-body-text--font-size:var(--body-04-font-size);
    --sic-body-text--line-height:var(--body-04-line-height);
  }

.sic-stats-block--stats{
  display:grid;
  grid-template-columns:1fr 1fr;
  row-gap:var(--spacing-08);
  column-gap:15%;
}

@media (min-width: 768px){

.sic-stats-block--stats{
    row-gap:var(--spacing-12)
}
  }
`;